module.exports = __webpack_public_path__ + "themes/fq/img/button-hover@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/button-hover@2x.png
// module id = 6
// module chunks = d-game